var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaileFileUploadIcon = function SvgFaileFileUploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E93",
    fillRule: "evenodd",
    d: "M7 1a1 1 0 0 0-1 1v21a9.96 9.96 0 0 1 6-2c5.523 0 10 4.477 10 10a9.96 9.96 0 0 1-2 6h13a1 1 0 0 0 1-1V11h-9a1 1 0 0 1-1-1V1zm12 30a7 7 0 1 1-14 0 7 7 0 0 1 14 0m1 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-4.147-3.146a.5.5 0 0 0-.707-.708L12 30.293l-3.147-3.147a.5.5 0 0 0-.707.708L11.293 31l-3.147 3.146a.5.5 0 1 0 .707.707L12 31.707l3.146 3.146a.5.5 0 1 0 .707-.707L12.707 31zM32.793 9H26.5a.5.5 0 0 1-.5-.5V2.207a.5.5 0 0 1 .854-.353l6.292 6.292a.5.5 0 0 1-.353.854",
    clipRule: "evenodd"
  })));
};
export default SvgFaileFileUploadIcon;